import { AbstractControl, ValidatorFn } from '@angular/forms';

export function positiveNumber(required: boolean = true): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if(!required && (control.value === '' || control.value === null)){
      return null;
    }
    const value = Number(control.value);
    return !isNaN(value) && (0 < value) ? null : {'invalidNumber': true};
  };

}

export function inRange(min: number, max: number, required: boolean = true): ValidatorFn {

  return (control: AbstractControl): { [key: string]: boolean } | null => {

    if(!required && (control.value === '' || control.value === null)){
      return null;
    }

    if (!control.hasError('invalidNumber')) {
      const value = Number(control.value);
      return !(control.value) || isNaN(control.value) || min < value && value < max ? null : { 'outOfRange': true };
    }

    return null;
  };

}
